module.exports = __webpack_public_path__ + "testimonial-logo-marriott.19_-SCmb.svg";